class ListAnalyticsV1 {

    constructor() {}


    setViewItemList(response) {
        let transferList = response.transferPriceList;
        let items = [];
        for (let index = 0; index < transferList.length; index++) {
            const element = transferList[index];
            const base = this.getBaseTransfer(response, element, index + 1);
            items.push(base);
        }

        let payload = {
            items: items
        };

        this.setTag('view_item_list', payload)

    }

    setAddToCart(response, transport, index) {
        let item = this.getBaseTransfer(response, transport, index);
        item.quantity = 1;

        let payload = {
            currency: "EUR",
            value: item.price,
            items: [item]
        };

        this.setTag('add_to_cart', payload)
    }


    getBaseTransfer(searchList, transport, index) {
        return {
            item_id: transport.transportId,
            item_name: transport.transportName,
            price: transport.price,
            item_brand: 'transport',
            item_category: `${searchList.pickupType} - ${searchList.dropoffType}`,
            item_list_name: `${transport.pickupName} > ${transport.dropoffName}`,
            index: index
        }
    }



    setTag(event, args) {
        if (window.gtag) {
            gtag('event', event, args)
        }
    }

}

export const ListAnalyticV1 = new ListAnalyticsV1();
